import { type QueryClient } from '@tanstack/react-query';

import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

import { type IReduxStateProvider } from '@/packages/redux-state/ReduxState';
import { queryKeySelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { listingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';
import { activePinListingIdSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';
import { getAnalyticsPage } from '@/packages/utils/analytics';
import { type CianAnalyticsPageViewObject } from '@/packages/utils/analytics/CianAnalyticsPageViewObject';
import { getAnalyticsProducts } from '@/packages/utils/analytics/getAnalyticsProducts';
import { getAnalyticsUser } from '@/packages/utils/analytics/getAnalyticsUser';

import { getSearchConditions } from './getSearchConditions';

export type GetCianAnalyticsPageViewObjectParams = {
  applicationContext: IApplicationContext;
  reduxState: IReduxStateProvider;
  queryClient: QueryClient;
};

export function getCianAnalyticsPageViewObject({
  reduxState,
  queryClient,
  applicationContext,
}: GetCianAnalyticsPageViewObjectParams): CianAnalyticsPageViewObject {
  const state = reduxState.getState();

  const activePinId = activePinListingIdSelector(state);

  const params = {
    queryClient,
    viewMode: listingLayoutViewModeSelector(state),
    activePinId,
    searchOffersQueryKey: queryKeySelector(state),
  };

  return {
    action: 'newpage',
    category: 'page',
    label: 'open',
    name: 'newpage',
    page: getAnalyticsPage(params),
    user: getAnalyticsUser(params),
    products: getAnalyticsProducts(params),
    searchConditions: getSearchConditions({ applicationContext, reduxState }),
  };
}
